import { Input, InputNumber, Select, Space } from 'antd';
import type { Keyword, Order } from './type';
import { FormItem } from './new';
import { ORDER, POSITIVE, NEGATIVE } from './const';
import { FC } from 'react';

/** 表格对象 */
const TableObjectItem: FC = () => {
  return (
    <FormItem noStyle dependencies={['table_order_type']}>
      {({ getFieldValue }) => {
        const type = getFieldValue('table_order_type') as Keyword | Order;

        if (type === ORDER) {
          return (
            <Space.Compact className="flex w-full">
              <FormItem noStyle name={['table_order', 'direction']}>
                <Select
                  className="flex-1"
                  options={[
                    {
                      label: '正数',
                      value: POSITIVE,
                    },
                    {
                      label: '倒数',
                      value: NEGATIVE,
                    },
                  ]}
                />
              </FormItem>
              <FormItem noStyle name={['table_order', 'offset']}>
                <InputNumber
                  className="flex-3"
                  min={1}
                  max={99999}
                  placeholder="请输入偏移量"
                />
              </FormItem>
            </Space.Compact>
          );
        }

        return (
          <FormItem
            className="flex-2 mb-0"
            name="keywords"
            rules={[
              {
                required: true,
                message: '',
                // validateTrigger: 'submit',
                warningOnly: true,
              },
            ]}
          >
            <Input allowClear placeholder="请输入关键词或正则表达式" />
          </FormItem>
        );
      }}
    </FormItem>
  );
};

export default TableObjectItem;
